<template>
  <v-card>
    <v-card-text class="pa-0">
      <v-simple-table>
        <thead class="v-data-table-header">
          <tr>
            <th>
              {{ $t('card_title.week') }}
            </th>
            <th>
              {{ $t('table_headers.weekly_load.sessions') }}
            </th>
            <th>
              {{ $t('table_headers.weekly_load.total_duration') }}
            </th>
            <th>
              {{ $t('table_headers.weekly_load.avg_rpe') }}
            </th>
            <th>
              {{ $t('table_headers.weekly_load.total_load') }}
            </th>
            <th>
              {{ $t('table_headers.weekly_load.avg_acute_load') }}
            </th>
            <th>
              {{ $t('table_headers.weekly_load.avg_load') }}
            </th>
            <th>
              {{ $t('table_headers.weekly_load.acute_chronic_ratio') }}
            </th>
            <th>
              {{ $t('table_headers.weekly_load.weekly_change') }}
            </th>
            <th>
              {{ $t('table_headers.weekly_load.avg_daily_load') }}
            </th>
            <th>
              {{ $t('table_headers.weekly_load.monotony') }}
            </th>
            <th>
              {{ $t('table_headers.weekly_load.strain') }}
            </th>
            <th v-if="showWellnessData">
              {{ $t('table_headers.weekly_load.wellness') }}
            </th>
          </tr>
        </thead>
        <tbody v-if="hasStats">
          <template v-for="weekCount in 7">
            <tr
              v-if="latestTeamStats['Week' + weekCount]"
              :key="weekCount + 'row'"
            >
              <td>
                {{ $t("card_title.week") }} -{{ weekCount }}
              </td>
              <td>
                <table-bar-value
                  :value="latestTeamStats['Week' + weekCount]['no_session']"
                  :max="maxValues['no_session']"
                  :color="getColorFromValue(latestTeamStats['Week' + weekCount]['no_session'], 15, true)"
                >
                  {{ latestTeamStats['Week' + weekCount]['no_session'] }}
                </table-bar-value>
              </td>
              <td>
                <table-bar-value
                  :value="latestTeamStats['Week' + weekCount]['TTM_sum']"
                  :max="maxValues['TTM_sum']"
                  :color="getColorFromValue(latestTeamStats['Week' + weekCount]['TTM_sum'], 800, true)"
                >
                  {{ latestTeamStats['Week' + weekCount]['TTM_sum'] }}
                </table-bar-value>
              </td>
              <td>
                <table-bar-value
                  :value="latestTeamStats['Week' + weekCount]['avg_rpe']"
                  :max="maxValues['avg_rpe']"
                  :color="getColorFromValue(latestTeamStats['Week' + weekCount]['avg_rpe'], 10, true)"
                >
                  {{ latestTeamStats['Week' + weekCount]['avg_rpe'] }}
                </table-bar-value>
              </td>
              <td>
                <table-bar-value
                  :value="latestTeamStats['Week' + weekCount]['total_load']"
                  :max="maxValues['total_load']"
                  color="grey lighten-2"
                >
                  {{ latestTeamStats['Week' + weekCount]['total_load'] }}
                </table-bar-value>
              </td>
              <td>
                <table-bar-value
                  :value="latestTeamStats['Week' + weekCount]['avg_al']"
                  :max="maxValues['avg_al']"
                  :color="getColorFromValue(latestTeamStats['Week' + weekCount]['avg_al'], 5000, true)"
                >
                  {{ latestTeamStats['Week' + weekCount]['avg_al'] }}
                </table-bar-value>
              </td>
              <td>
                <table-bar-value
                  :value="latestTeamStats['Week' + weekCount]['avg_tl']"
                  :max="maxValues['avg_tl']"
                  :color="getColorFromValue(latestTeamStats['Week' + weekCount]['avg_tl'], 1700, true)"
                >
                  {{ latestTeamStats['Week' + weekCount]['avg_tl'] }}
                </table-bar-value>
              </td>
              <td>
                <table-bar-value
                  :value="latestTeamStats['Week' + weekCount]['al_cl']"
                  :max="maxValues['al_cl']"
                  :color="getAcwrColorFromValue(latestTeamStats['Week' + weekCount]['al_cl'])"
                >
                  {{ latestTeamStats['Week' + weekCount]['al_cl'] }}
                </table-bar-value>
              </td>
              <td>
                {{ latestTeamStats['Week' + weekCount]['wc'] >= 0 ? '+' : '' }}{{ latestTeamStats['Week' + weekCount]['wc'] }}
                <v-icon
                  v-if="latestTeamStats['Week' + weekCount]['wc'] !== 0"
                  small
                  class="ml-1"
                  :color="latestTeamStats['Week' + weekCount]['wc'] > 0 ? 'green' : 'red'"
                >
                  {{ latestTeamStats['Week' + weekCount]['wc'] > 0 ? 'fal fa-arrow-trend-up' : 'fal fa-arrow-trend-down' }}
                </v-icon>
              </td>
              <td>
                <table-bar-value
                  :value="latestTeamStats['Week' + weekCount]['avg_dl']"
                  :max="maxValues['avg_dl']"
                  color="grey lighten-2"
                >
                  {{ latestTeamStats['Week' + weekCount]['avg_dl'] }}
                </table-bar-value>
              </td>
              <td>
                <table-bar-value
                  :value="latestTeamStats['Week' + weekCount]['monotony']"
                  :max="maxValues['monotony']"
                  :color="getColorFromValue(latestTeamStats['Week' + weekCount]['monotony'], 3, true)"
                >
                  {{ latestTeamStats['Week' + weekCount]['monotony'] }}
                </table-bar-value>
              </td>
              <td>
                <table-bar-value
                  :value="latestTeamStats['Week' + weekCount]['strain']"
                  :max="maxValues['strain']"
                  color="grey lighten-2"
                >
                  {{ latestTeamStats['Week' + weekCount]['strain'] }}
                </table-bar-value>
              </td>
              <td v-if="showWellnessData">
                <table-bar-value
                  :value="latestTeamStats['Week' + weekCount]['avg_wellness']"
                  :max="100"
                  :color="latestTeamStats['Week' + weekCount]['avg_wellness'] >= 90 ? 'green' : (latestTeamStats['Week' + weekCount]['avg_wellness'] > 70 ? 'orange' : 'red')"
                >
                  {{ latestTeamStats['Week' + weekCount]['avg_wellness'] }} %
                </table-bar-value>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td
              colspan="11"
              class="text-center pa-6"
            >
              {{ $t('data_empty') }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { getColorForValue, getColorForValueWithDefinition, processMaxValues } from '@/utils/helpers'
import TableBarValue from '@/components/helpers/TableBarValue.vue'
import { acwrColorsDefinition } from '@/data/models/Stats'

export default {
  name: 'TrainingLoadWeeklyTeamTable',
  components: { TableBarValue },
  props: {
    latestTeamStats: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      maxValues: {}
    }
  },
  computed: {
    hasStats() {
      return !!this.latestTeamStats.Week1
    },
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    showWellnessData() {
      return !this.user.organisation_settings.has_short_wellness_feedback
    }
  },
  created() {
    if (!this.hasStats) return

    const stats = []

    for (let i = 1; i <= 7; i++) {
      if (this.latestTeamStats['Week' + i]) stats.push(this.latestTeamStats['Week' + i])
    }

    this.maxValues = processMaxValues(stats)
  },
  methods: {
    getColorFromValue(value, max, reverse) {
      return getColorForValue(value, max, reverse)
    },
    getAcwrColorFromValue(value) {
      return getColorForValueWithDefinition(value, acwrColorsDefinition)
    }
  }
}
</script>

<style scoped>

</style>
